/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

// ENH-052: no-login (guest) referral access.
// Action Declarations — ORG_MODULE_ACTION_ANY
export const getGuestReferralAction = createAction('REFORAL_GET_GUEST_REFERRAL');
export const requestGuestLinkAction = createAction('REFORAL_REQUEST_GUEST_LINK');
export const resendGuestLinkAction = createAction('REFORAL_RESEND_GUEST_LINK');
export const revokeGuestLinkAction = createAction('REFORAL_REVOKE_GUEST_LINK');
export const downloadGuestAttachmentAction = createAction('REFORAL_DOWNLOAD_GUEST_ATTACHMENT');
export const downloadAllGuestAttachmentsAction = createAction('REFORAL_DOWNLOAD_ALL_GUEST_ATTACHMENTS');

// ENH-052: guest referral submission through a clinic's public link.
export const getGuestReferLinkAction = createAction('REFORAL_GET_GUEST_REFER_LINK');
export const getGuestReferCatalogAction = createAction('REFORAL_GET_GUEST_REFER_CATALOG');
export const validateGuestReferStepAction = createAction('REFORAL_VALIDATE_GUEST_REFER_STEP');
export const submitGuestReferralAction = createAction('REFORAL_SUBMIT_GUEST_REFERRAL');
